import React, { useState } from "react";

const TraceTable = () => {
  const initialHeader = ["Step", "i", "Total (Before)", "Operation", "Total (After)"];
  const initialExample = [
    ["1", "1", "0", "Total = 0 + 1", "1"],
    ["2", "2", "1", "Total = 1 + 2", "3"],
    ["3", "3", "3", "Total = 3 + 3", "6"]
  ];

  const [header, setHeader] = useState(initialHeader);
  const [rows, setRows] = useState([Array(initialHeader.length).fill("")]);
  const [finalOutput, setFinalOutput] = useState("Final Output:");

  const styles = {
    body: {
      background: "radial-gradient(circle at top, #0f2027, #203a43, #2c5364)",
      color: "#f1f1f1",
      fontFamily: "Poppins, sans-serif",
      textAlign: "center",
      padding: "25px",
       minHeight: "100vh",
    },
    h1: {
      color: "#00e5ff",
      textShadow: "0 0 8px #00e5ff",
      marginBottom: "10px"
    },
    textarea: {
      width: "65%",
      height: "60px",
      border: "none",
      borderRadius: "10px",
      background: "#1c1c1c",
      color: "#fff",
      fontSize: "1rem",
      padding: "10px",
      marginTop: "8px",
      boxShadow: "0 0 10px #00bcd4"
    },
    table: {
      width: "90%",
      margin: "25px auto",
      borderCollapse: "collapse",
      background: "#1e1e1e",
      borderRadius: "10px",
      overflow: "hidden",
      boxShadow: "0 0 15px #00bcd4aa"
    },
    th: {
      border: "1px solid #333",
      padding: "10px",
      textAlign: "center",
      backgroundColor: "#222",
      color: "#00e5ff"
    },
    td: {
      border: "1px solid #333",
      padding: "10px",
      textAlign: "center"
    },
    input: {
      width: "95%",
      padding: "5px",
      background: "#2c2c2c",
      border: "1px solid #444",
      color: "#fff",
      borderRadius: "5px",
      textAlign: "center"
    },
    btn: {
      backgroundColor: "#00e5ff",
      color: "#000",
      border: "none",
      padding: "10px 18px",
      margin: "8px 5px",
      borderRadius: "6px",
      cursor: "pointer",
      transition: "0.3s",
      fontWeight: "bold"
    },
    controls: { marginTop: "15px" },
    finalOutput: {
      fontSize: "1.3em",
      color: "#00e676",
      marginTop: "20px",
      fontWeight: "bold"
    }
  };

  /* Helper functions */
  const addRow = () => {
    setRows([...rows, Array(header.length).fill("")]);
  };

  const removeRow = () => {
    if (rows.length > 1) {
      setRows(rows.slice(0, -1));
    } else {
      setRows([Array(header.length).fill("")]);
    }
  };

  const addColumn = () => {
    setHeader([...header, "New Column"]);
    setRows(rows.map((row) => [...row, ""]));
  };

  const removeColumn = () => {
    if (header.length > 1) {
      setHeader(header.slice(0, -1));
      setRows(rows.map((row) => row.slice(0, -1)));
    }
  };

  const clearTable = () => {
    setRows([Array(header.length).fill("")]);
    setFinalOutput("Final Output:");
  };

  const revealExample = () => {
    setRows(initialExample);
    setFinalOutput("Final Output: 6 ✅");
  };

  const updateCell = (rowIndex, colIndex, value) => {
    const newRows = rows.map((row, r) =>
      r === rowIndex ? row.map((cell, c) => (c === colIndex ? value : cell)) : row
    );
    setRows(newRows);
  };

  return (
    <div style={styles.body}>
      <h3 style={styles.h1}>@ Build Your Own Trace Table!</h3>
      <p>Type your question, add rows & columns, and fill your table like a real programmer!</p>

      <textarea style={styles.textarea} placeholder="Type your trace table question here..." />

      <div style={styles.controls}>
        <button style={styles.btn} onClick={addRow}>➕ Add Row</button>
        <button style={styles.btn} onClick={removeRow}>➖ Remove Row</button>
        <button style={styles.btn} onClick={addColumn}>➕ Add Column</button>
        <button style={styles.btn} onClick={removeColumn}>➖ Remove Column</button>
        <button style={styles.btn} onClick={clearTable}>🧹 Clear</button>
        <button style={styles.btn} onClick={revealExample}>👀 Show Example</button>
      </div>

      <table style={styles.table}>
        <thead>
          <tr>
            {header.map((col, i) => (
              <th key={i} style={styles.th} contentEditable>{col}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, r) => (
            <tr key={r}>
              {row.map((cell, c) => (
                <td key={c} style={styles.td}>
                  <input
                    type="text"
                    style={styles.input}
                    value={cell}
                    onChange={(e) => updateCell(r, c, e.target.value)}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>

      {/* <div style={styles.finalOutput}>{finalOutput}</div> */}
    </div>
  );
};

export default TraceTable;